module.exports = __webpack_public_path__ + "static/img/Maastricht.7af1ef9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Maastricht.jpg
// module id = xpR0
// module chunks = 1